// import React from "react";

// export type Router = {
// pathname: string;
// searchParams: URLSearchParams;
// navigate: (path: string | URL) => void;
// };
// export default function useDemoRouter(
//   initialPath: string,
//   navigateTo: (path: string) => void
// ): {
//   router: Router;
//   setPathname: React.Dispatch<React.SetStateAction<string>>;
// } {
//   const [pathname, setPathname] = React.useState(initialPath);

//   const navigate = React.useCallback(
//     (path: string | URL) => {
//       const newPath = String(path);
//       setPathname(newPath); // async update
//       navigateTo(`/erp/pages${newPath}`); // use immediate value
//     },
//     [navigateTo]
//   );

//   const router: Router = {
//     pathname,
//     searchParams: new URLSearchParams(),
//     navigate,
//   };

//   return { router, setPathname };
// }


import React from "react";
import { useLocation } from "react-router-dom";

export type Router = {
  pathname: string;
  searchParams: URLSearchParams;
  navigate: (path: string | URL) => void;
};

export default function useDemoRouter(
  initialPath: string,
  navigateTo: (path: string) => void
): {
  router: Router;
  setPathname: React.Dispatch<React.SetStateAction<string>>;
} {
  const location = useLocation();
  const [pathname, setPathname] = React.useState(initialPath);

  // Sync custom pathname with actual location
  React.useEffect(() => {
    const currentPath = location.pathname.replace("/erp/pages", "");
    setPathname(currentPath);
  }, [location.pathname]);

  const navigate = React.useCallback(
    (path: string | URL) => {
      const newPath = String(path);
      setPathname(newPath); // update internal state
      navigateTo(`/erp/pages${newPath}`); // update actual URL
    },
    [navigateTo]
  );

  const router: Router = {
    pathname,
    searchParams: new URLSearchParams(location.search),
    navigate,
  };

  return { router, setPathname };
}
